import { AppointmentPractitioner } from '@dreryk/egabinet-appointment-frontend-api';

import { TimetableSlotSelectionEvent } from '@dreryk/react-calendar';
import { customEventFactory } from '@dreryk/react-common';

const APPOINTMENTS_TIMETABLE_SLOT_SELECTION_EVENT = 'AppointmentsTimetableSlotSelectionEvent';

const [
   dispatchAppointmentsTimetableSlotSelectionEventEvent,
   registerAppointmentsTimetableSlotSelectionEventListener,
] = customEventFactory<TimetableSlotSelectionEvent<AppointmentPractitioner>>(
   APPOINTMENTS_TIMETABLE_SLOT_SELECTION_EVENT
);

export {
   dispatchAppointmentsTimetableSlotSelectionEventEvent,
   registerAppointmentsTimetableSlotSelectionEventListener,
};
